{
  "name": "corporate-client",
  "version": "4.0.39",
  "scripts": {
    "build_production": "ng build --optimization --aot --configuration production",
    "build_sandbox": "ng build --optimization --aot --configuration test",
    "build_staging": "ng build --optimization --aot --configuration staging",
    "build_training": "ng build --optimization --aot --configuration training",
    "check:dep": "npx depcheck",
    "lint-fix": "ng lint --fix",
    "prebuild": "npm --no-git-tag-version version patch",
    "prebuild_production": "npm --no-git-tag-version version patch",
    "prebuild_staging": "npm --no-git-tag-version version patch",
    "prebuild_training": "npm --no-git-tag-version version patch",
    "precommit": "lint-staged",
    "prettier:check": "prettier --check **/**/*.{json,css,js,yml,yaml,md}",
    "prettier:format": "npx prettier --write .",
    "start": "ng serve",
    "test": "ng test",
    "test:prod": "ng build && http-server -c-1 dist/",
    "watch": "ng build --watch --configuration development",
    "build:tailwind": "npx tailwindcss -c ./tailwind.config.js -i ./public/css/tailwind.css -o ./public/css/tailwind.out.css --watch",
    "lint": "ng lint",
    "prepare": "husky"
  },
  "lint-staged": {
    "*.{js,ts,tsx}": [
      "npx eslint",
      "npm run prettier:format"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.14",
    "@angular/cdk": "^19.2.17",
    "@angular/common": "^19.2.14",
    "@angular/compiler": "^19.2.14",
    "@angular/core": "^19.2.14",
    "@angular/forms": "^19.2.14",
    "@angular/material": "^19.2.17",
    "@angular/platform-browser": "^19.2.14",
    "@angular/platform-browser-dynamic": "^19.2.14",
    "@angular/platform-server": "^19.2.14",
    "@angular/router": "^19.2.14",
    "@angular/service-worker": "^19.2.14",
    "@googlemaps/js-api-loader": "^1.16.8",
    "@kimbocare/auth": "^0.2.1",
    "@kimbocare/core": "^0.3.50",
    "@kimbocare/ui": "^0.3.96",
    "@kurkle/color": "^0.4.0",
    "@ngrx/component-store": "^19.2.0",
    "@ngrx/data": "^19.2.0",
    "@ngrx/effects": "^19.2.0",
    "@ngrx/entity": "^19.2.0",
    "@ngrx/store": "^19.2.0",
    "@ngrx/store-devtools": "^19.2.0",
    "@ngx-translate/core": "^16.0.4",
    "apexcharts": "^4.7.0",
    "bootstrap": "^5.3.3",
    "chart.js": "^4.4.9",
    "crypto-js": "^4.2.0",
    "email-validator": "^2.0.4",
    "google-libphonenumber": "^3.2.41",
    "jquery": "^3.7.1",
    "lottie-web": "^5.13.0",
    "moment": "^2.30.1",
    "ng-apexcharts": "^1.15.0",
    "ngrx-store-localstorage": "^19.0.0",
    "ngx-bootstrap": "^19.0.2",
    "ngx-extended-pdf-viewer": "^23.2.0",
    "ngx-infinite-scroll": "^19.0.0",
    "ngx-lottie": "^13.0.1",
    "ngx-mask": "^19.0.7",
    "ngx-owl-carousel-o": "^19.0.2",
    "ngx-toastr": "^19.0.0",
    "ngx-translate-multi-http-loader": "^19.0.3",
    "ngx-webcam": "^0.4.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.14",
    "@angular/cli": "^19.2.14",
    "@angular/compiler-cli": "^19.2.14",
    "@meddv/ngx-pinch-zoom": "^19.0.0",
    "@types/express": "^4.17.17",
    "@types/google-libphonenumber": "^7.4.30",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^18.19.121",
    "angular-eslint": "18.4.3",
    "autoprefixer": "^10.4.10",
    "eslint": "^9.15.0",
    "husky": "^9.1.7",
    "jasmine-core": "~5.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^15.4.3",
    "prettier": "^3.4.2",
    "tailwindcss": "^3.4.17",
    "typescript": "~5.7.2",
    "typescript-eslint": "8.16.0"
  }
}
